module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("12HYq"))).then(() => parcelRequire('fThBo'));